import { render, staticRenderFns } from "./PendingDependentsChildList.vue?vue&type=template&id=0a23963c&"
import script from "./PendingDependentsChildList.vue?vue&type=script&lang=js&"
export * from "./PendingDependentsChildList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports